// extracted by mini-css-extract-plugin
module.exports = {"carousel-dots-container":"styles__carousel-dots-container___3RiYR","carousel-dot-button":"styles__carousel-dot-button___YccGu","dot-active":"styles__dot-active___3HyYe"};